import { Button, Card, Col, Collapse, Divider, Form, Image, Input, InputNumber, Modal, Popconfirm, Radio, Row, Select, Spin, Switch, TimePicker, Tooltip, notification } from 'antd';
import * as Api from 'api';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import classes from './style.module.scss';
import { optionsMC2 } from '../options';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const format = 'HH:mm';

const CameraRemoteMC2Advanced = ({ IMEI, setting, onChange, onSend, device }) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [switchPir, setSwitchPir] = useState(true);
  const [workTimer1, setWorkTimer1] = useState(true);
  const [workTimer2, setWorkTimer2] = useState(true);
  const [isModalPlayVideo, setIsModalPlayVideo] = useState(false);
  const [videoLength, setVideoLength] = useState('3');
  const [isInActionshot, setIsInActionshot] = useState(false);

  const [pendingPicSizeValue, setPendingPicSizeValue] = useState(null);
  const [confirmPicSizeVisible, setConfirmPicSizeVisible] = useState(false);
  const [pendingTransmittedValue, setPendingTransmittedValue] = useState(null);
  const [confirmTransmittedVisible, setConfirmTransmittedVisible] = useState(false);

  const handleConfirmPicSize = () => {
    form.setFieldsValue({ pic_size: pendingPicSizeValue });
    setConfirmPicSizeVisible(false);
    onChangeForm();
  };

  const handleCancelPicSize = () => {
    setPendingPicSizeValue(null);
    setConfirmPicSizeVisible(false);
  };

  const handleSelectChangePicSize = (value) => {
    setPendingPicSizeValue(value);
    setConfirmPicSizeVisible(true);
  };

  const handleConfirmTransmitted = () => {
    form.setFieldsValue({ image_transmitted: pendingTransmittedValue });
    setConfirmTransmittedVisible(false);
    onChangeForm();
  };

  const handleCancelTransmitted = () => {
    setPendingTransmittedValue(null);
    setConfirmTransmittedVisible(false);
  };

  const handleSelectChangeTransmitted = (value) => {
    setPendingTransmittedValue(value);
    setConfirmTransmittedVisible(true);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (device.firmware_version >= 'GLR1HArF703') {
        Api.MC2_ACTIONSHOT_STATE(IMEI).then((res: any) => {
          const data = JSON.parse(res.text);
          if (data.result == 'OK') {
            setIsInActionshot(data.status == 'actionshot_start');
          }
        }).catch((error: any) => {
          setLoading(false);
          console.log('error ===>', error);
        });
      }
    }, 2000); // run every 2 second

    return () => clearInterval(interval); // cleanup on unmount
  }, [device]);

  useEffect(() => {
    if (setting) {
      let pir_interval_value = setting.pir_interval;
      if (pir_interval_value == 'OFF') {
        setSwitchPir(false);
        pir_interval_value = moment('00:00:00', 'HH:mm:ss');
      } else {
        setSwitchPir(true);
        pir_interval_value = moment(pir_interval_value, 'HH:mm:ss');
      }
      let work_timer_1_value = [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')];
      if (setting.work_timer_1 == 'OFF') {
        setWorkTimer1(false);
      } else {
        setWorkTimer1(true);
        const work_time = setting.work_timer_1.split('-');
        work_timer_1_value = [moment(work_time[0], 'HH:mm'), moment(work_time[1], 'HH:mm')];
      }
      let work_timer_2_value = [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')];
      if (setting.work_timer_2 == 'OFF') {
        setWorkTimer2(false);
      } else {
        setWorkTimer2(true);
        const work_time = setting.work_timer_2.split('-');
        work_timer_2_value = [moment(work_time[0], 'HH:mm'), moment(work_time[1], 'HH:mm')];
      }

      form.setFieldsValue({ ...setting, pir_interval_value, work_timer_1_value, work_timer_2_value });
    }
  }, [setting]);

  const onFinish = () => {
    onSend();
  };

  useEffect(() => {
    onChangeForm();
  }, [workTimer1, workTimer2, switchPir]);

  const onChangeForm = () => {
    const values = form.getFieldsValue();
    const updatedSetting = {};
    for (let [key, value] of Object.entries(values)) {
      if (key == 'work_timer_1_value') {
        key = 'work_timer_1';
        if (value && workTimer1) {
          const time1 = values.work_timer_1_value[0].format(format);
          const time2 = values.work_timer_1_value[1].format(format);
          value = `${time1}-${time2}`;
        } else {
          value = 'OFF';
        }
      } else if (key == 'work_timer_2_value') {
        key = 'work_timer_2';
        if (value && workTimer2) {
          const time1 = values.work_timer_2_value[0].format(format);
          const time2 = values.work_timer_2_value[1].format(format);
          value = `${time1}-${time2}`;
        } else {
          value = 'OFF';
        }
      } else if (key == 'pir_interval_value') {
        key = 'pir_interval';
        if (value && switchPir) {
          value = values.pir_interval_value.format('HH:mm:ss');
        } else {
          value = 'OFF';
        }
      }
      updatedSetting[key] = value;
      key = '';
    }
    onChange(updatedSetting);
  };

  const http_formware_update = () => {
    setIsModalOpen(false);
    const params = {
      IMEI,
    };
    setLoading(true);
    Api.MC2_FIRMWARE_UPDATE(params).then((res: any) => {
      setLoading(false);
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        const date = new Date(data.estimated_time * 1000).toLocaleString();
        const confirm_message = `Your update request has been sent to the camera and should be completed by ${date}. Please check back at that time.`;
        notification.open({
          message: confirm_message,
        });
      } else {
        notification.open({
          message: data.message,
          duration: 10,
        });
      }
    }).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const http_sendcommand = (cmd, param) => {
    const params = {
      IMEI,
      command: cmd,
      param,
    };
    setLoading(true);
    Api.MC2_SEND_COMMAND(params).then((res: any) => {
      setLoading(false);
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        notification.open({
          message: data.message,
        });
      } else {
        notification.open({
          message: res.text,
          duration: 10,
        });
      }
    }).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const on_play_video = () => {
    setIsModalPlayVideo(false);
    http_sendcommand('actionshot', videoLength);
  };

  return (
    <Spin spinning={loading} size="large">
      <Collapse defaultActiveKey={[]}>
        <Collapse.Panel header="Advanced Settings" key="1">
          <Form
            {...layout}
            form={form}
            name="advanced"
            onValuesChange={onChangeForm}
            onFinish={onFinish}
          >
            <Row>
              <Col md={12} xs={24}>
                <Form.Item
                  label="Sending Mode"
                  name="frequency"
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsMC2.Frequency}
                  />
                </Form.Item>
                <Form.Item
                  label="Motion Sensor"
                  name="pir_switch"
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsMC2.PirSwitch}
                  />
                </Form.Item>
                <Form.Item
                  label="Flash Distance"
                  name="flash_distance"
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsMC2.FlashDistance}
                  />
                </Form.Item>
                <Form.Item
                  label="Night Mode"
                  name="night_vision"
                  tooltip={{ title: 'This controls the shutter speed at night. Max Range will illuminate things further away, but it will tend to create more blur. Minimum Blur will reduce the amount of blurriness in the photo, but it will reduce the range of the flash at night. Balanced is good for most situations.', placement: 'bottom' }}
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsMC2.NightVision}
                  />
                </Form.Item>
                <Form.Item
                  label="Color Mode"
                  name="color_mode"
                  hidden={device.firmware_version < 'GLR1HArF703'}
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsMC2.ColorMode}
                  />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  label="Picture Size"
                  name="pic_size"
                  tooltip={{ title: 'This is the size of the picture that is saved on the SD Card. This will not affect the size of the images transmitted to HuntControl.', placement: 'bottom' }}
                >
                  <Popconfirm
                    title={(
                      <div>
                        This will not affect the physical size of the images transmitted to HuntControl.<br />
                        This only directly affects the size of the image saved to the memory of the camera.<br />
                        It can cause the images to use more data, and may affect your data usage.<br />
                        Do you wish to proceed with the change?
                      </div>
                    )}
                    visible={confirmPicSizeVisible}
                    onConfirm={handleConfirmPicSize}
                    onCancel={handleCancelPicSize}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Select
                      className={classes.control}
                      size="large"
                      onChange={handleSelectChangePicSize}
                      value={form.getFieldValue('pic_size')}
                      options={optionsMC2.PicSize}
                    />
                  </Popconfirm>
                </Form.Item>
                <Form.Item
                  label="Image Transmitted"
                  name="image_transmitted"
                  hidden={device.show_transmitted == 0}
                >
                  <Popconfirm
                    title={(
                      <div>
                        This will change the physical size of the images sent to HuntControl.<br />
                        If you change to larger, you will use more data per image transmitted which will decrease your data faster<br />
                        It can cause the images to use more data, and may affect your data usage.<br />
                        Do you wish to proceed?
                      </div>
                    )}
                    visible={confirmTransmittedVisible}
                    onConfirm={handleConfirmTransmitted}
                    onCancel={handleCancelTransmitted}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Select
                      className={classes.control}
                      size="large"
                      onChange={handleSelectChangeTransmitted}
                      value={form.getFieldValue('image_transmitted')}
                      options={optionsMC2.ImageTransmitted}
                    />
                  </Popconfirm>
                </Form.Item>
                <Form.Item
                  label="Time Lapse"
                >
                  <Input.Group compact>
                    <Form.Item
                      label=""
                      name="pir_interval_value"
                    >
                      <TimePicker
                        className={classes.control}
                        size="large"
                        disabled={!switchPir}
                      />
                    </Form.Item>
                    &nbsp;
                    <Form.Item
                      label=""
                    >
                      <Switch
                        checked={switchPir}
                        onChange={(checked) => {
                          console.log(`switch to ${checked}`);
                          setSwitchPir(checked);
                          if (checked) {
                            form.setFieldsValue({ pir_interval_value: moment('00:00:10', 'HH:mm:ss') });
                          }
                        }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
                <Form.Item
                  label="Work Timer1"
                  className={classes.divTimeLapse}
                  tooltip={{ title: 'Select which hours during the day that you would like the camera to be active. Do not set this if you wish the camera to always be active.', placement: 'bottom' }}
                >
                  <Input.Group compact>
                    <Form.Item
                      label=""
                      name="work_timer_1_value"
                    >
                      <TimePicker.RangePicker
                        className={classes.control}
                        size="large"
                        disabled={!workTimer1}
                        format={format}
                      />
                    </Form.Item>
                    &nbsp;
                    <Form.Item
                      label=""
                    >
                      <Switch
                        checked={workTimer1}
                        onChange={(checked) => {
                          console.log(`switch to ${checked}`);
                          setWorkTimer1(checked);
                          if (checked) {
                            form.setFieldsValue({ work_timer_1_value: [moment('00:00', 'HH:mm'), moment('00:05', 'HH:mm')] });
                          }
                        }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
                <Form.Item
                  label="Work Timer2"
                  className={classes.divTimeLapse}
                  tooltip={{ title: 'Select which hours during the day that you would like the camera to be active. Do not set this if you wish the camera to always be active.', placement: 'bottom' }}
                >
                  <Input.Group compact>
                    <Form.Item
                      label=""
                      name="work_timer_2_value"
                    >
                      <TimePicker.RangePicker
                        className={classes.control}
                        size="large"
                        disabled={!workTimer2}
                        format={format}
                      />
                    </Form.Item>
                    &nbsp;
                    <Form.Item
                      label=""
                    >
                      <Switch
                        checked={workTimer2}
                        onChange={(checked) => {
                          console.log(`switch to ${checked}`);
                          setWorkTimer2(checked);
                          if (checked) {
                            form.setFieldsValue({ work_timer_2_value: [moment('00:00', 'HH:mm'), moment('00:05', 'HH:mm')] });
                          }
                        }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
            </Row>
            <Modal title="" visible={isModalOpen} onOk={http_formware_update} onCancel={() => { setIsModalOpen(false); }}>
              <p>The update may take up to 48hrs to complete. During this time you will be unable to send additional remote control commands. The camera will have to have sufficient battery power and signal for the update to complete properly. After the update, your camera will revert to the default values for all settings. Your camera will continue to send images during the update process. None of your images or data will be affected during the update. Do you wish to proceed?</p>
            </Modal>
            <div className={classes.divFooter}>
              <Button type="primary" style={{ float: 'right' }} htmlType="submit">
                Save
              </Button>
            </div>
            <Modal title="ActionShot" visible={isModalPlayVideo} onCancel={() => { setIsModalPlayVideo(false); }} onOk={on_play_video}>
              <p>ActionShot videos are too large to be sent over cellular, please retrieve your video from the SD card or internal memory of the camera. If you have an SD card in the camera, the video should be on the SD card.</p>
              <Radio.Group value={videoLength} onChange={(arg) => setVideoLength(arg.target.value)}>
                <Radio.Button value="1">1 minute</Radio.Button>
                <Radio.Button value="2">2 minutes</Radio.Button>
                <Radio.Button value="3">3 minutes</Radio.Button>
              </Radio.Group>
            </Modal>
          </Form>
          <Divider />
          <div className={classes.divBottom}>
            <div className={classes.divLine}>
              <Button type="primary" disabled={device.is_last_firmware} onClick={() => setIsModalOpen(true)}>
                Camera Firmware Upgrade
              </Button>
            </div>
            <div className={classes.divLine}>
              <Tooltip placement="bottom" title="The reset command can resolve many common issues with the camera. Only use if you are having trouble with your camera. This will remove all of your settings from the camera. Do you wish to proceed?">
                <Popconfirm title="Sure to Reset?" onConfirm={() => http_sendcommand('reset', 0)}>
                  <Button type="primary">
                    Reset
                  </Button>
                </Popconfirm>
              </Tooltip>
            </div>
            <div className={classes.divLine} style={{ display: isInActionshot ? 'none' : '' }}>
              <Button type="primary" disabled={device.show_transmitted == 0} onClick={() => setIsModalPlayVideo(true)}>
                ActionShot
              </Button>
            </div>
            <div className={classes.divLine} style={{ display: isInActionshot ? '' : 'none' }}>
              <div>
                <Image preview={false} src="/icons/img_icon_as.png" width={80} height={80} />
                <p>In Progress</p>
              </div>
            </div>
            <div className={classes.divLine}>
              <Button type="primary" onClick={() => http_sendcommand('format', 0)}>
                SD Format
              </Button>
            </div>
          </div>
        </Collapse.Panel>
      </Collapse>
    </Spin>
  );
};

export default CameraRemoteMC2Advanced;
